import API from "./API";
import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                Alert.warning("Λογαριασμός", "Έχεις αποσυνδεθεί από τον λογαριασμό σου!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
        editSettings: (data) => API.POST('edit-settings', data),
    },

    client: {
        index: (data) => API.POST('clients', data),
        details: (id) => API.GET(`client/${id}/details`),
        create: (data) => API.POST('client/create', data),
        edit: (data) => API.POST(`client/edit`, data),
        delete: (id) => API.POST('client/delete', {id}),
    },

    order: {
        index: (data) => API.POST('orders', data),
        initialize: () => API.GET('order/initialize'),
        details: (id) => API.GET(`order/${id}/details`),
        create: (data) => API.POST('order/create', data),
        edit: (data) => API.POST(`order/edit`, data),
        delete: (id) => API.POST('order/delete', {id}),
        exportSamples: (samples) => API.POST('order/export-samples', samples),
        exportOrder: (id) => API.POST('order/export-order', {id}),
        // sampleTypeValues: (data) => API.POST('order/sample-type-values', data),
    },

    sample: {
        index: (data) => API.POST('samples', data),
        details: (id) => API.GET(`sample/${id}/details`),
        edit: (data) => API.POST(`sample/edit`, data),
        types: (data) => API.POST('sample/types', data),
        characterizations: (data) => API.POST('sample/characterizations', data),
        // statistics: (data) => API.POST('sample/statistics', data),
        // typeInfo: (data) => API.POST('sample/type-info', data),
        exportPdf: (data) => API.POST('sample/export-pdf', data),
        statsExcel: (data) => API.POST('sample/stats-excel', data),
        cloudAnalyses: (data) => API.POST('sample/cloud-analyses', data),
        exportExcel: (data) => API.POST('sample/export-excel', data),
        toggleCloud: (data)=> API.POST('sample/toggle-cloud', data),
        // setClientVisibility: (data) => API.POST('sample/set-client-visibility', data),
    },

    analyses: {
        index: (data) => API.POST('analyses', data),
        details: (id) => API.GET(`analysis/${id}/details`),
        create: (data) => API.POST('analysis/create', data),
        edit: (data) => API.POST(`analysis/edit`, data),
        delete: (id) => API.POST('analysis/delete', {id}),
        fieldValues: (data) => API.POST('analysis/field-values', data),
    },

    analysisGroup: {
        index: () => API.GET('analysis-groups'),
        details: (id) => API.GET(`analysis-group/${id}/details`),
        create: (data) => API.POST('analysis-group/create', data),
        edit: (data) => API.POST(`analysis-group/edit`, data),
        delete: (id) => API.POST('analysis-group/delete', {id}),
        editAnalyses: (data) => API.POST(`analysis-group/edit-analyses`, data),
        setOrder: (data) => API.POST(`analysis-group/set-order`, data),
    },

    fieldCategory: {
        index: () => API.GET('field-categories'),
        details: (id) => API.GET(`field-category/${id}/details`),
        create: (data) => API.POST('field-category/create', data),
        edit: (data) => API.POST(`field-category/edit`, data),
        delete: (id) => API.POST('field-category/delete', {id}),
        order: (data) => API.POST(`field-category/order`, data),
    },

    user: {
        index: (data) => API.POST('users', data),
        details: (id) => API.GET(`user/${id}/details`),
        create: (data) => API.POST('user/create', data),
        edit: (data) => API.POST(`user/edit`, data),
        delete: (id) => API.POST('user/delete', {id}),
    },

};

export default R;
export {mm as requestingStore};